import {popupEditUser, popupResetPassword} from "../common/PopupForms";

export function tableWorkers(HelperTable) {

    const selectorTable = '#table_workers';
    const elTable = $(selectorTable)
    const canCreate = ESR.Helper.canCreate();
    const canEditOther = ESR.Helper.canEditOther();
    const canEditUsers = ESR.Helper.userCan('edit_users');
    const canViewReports = ESR.Helper.userCan('view_reports')
    const canViewTools = ESR.Helper.userCan('view_tool_assignment')
    const canViewReportUser = ESR.Helper.userCan('view_report_worker')
    const currentUserID = ESR.user.id
    if (!elTable?.length) {
        return;
    }



    const columnActions = canViewReports || canViewTools ? [
        {
            label: "Instrumente",
            data: 'id',
            orderable: false,
            className: 'no-export',
            render: (data, type) => {

                if (type === 'display' && canViewTools) {
                    const url = ESR.Helper.getPageUrl({pageKey: 'worker', endpointKey: data}) + 'tools/'
                    return `<a href="${url}" class="btn-action">Instrumente</a>`
                }

                return data;
            }
        }
    ] : [];

    const columns = [
        {
            label: ESR.lang.user_name,
            data: 'name',
            orderable: true,
            render: (data, type, row) => {

                if (type === 'display') {
                    const isSameUser = parseInt(row.id) === parseInt(currentUserID)
                    if (canViewReports || (canViewReportUser && isSameUser)) {
                        return `<a href="${ESR.Helper.getReportWorkerUrl({id: row.id})}">${data}</a>`
                    }
                }

                return data;
            }
        },
        ...columnActions,
        {
            label: ESR.lang.role,
            data: 'role',
            orderable: true,
            render: (data, type, row) => row.role.label
        },
        {label: ESR.lang.email, data: 'email', orderable: false},
        { label: ESR.lang.phone_number, data: 'phone', orderable: false}
    ];

    if (canEditUsers) {
        const columnDefinitions = [
            {label: ESR.lang.id, data: 'id', orderable: true, visible : true},
            {label: ESR.lang.login, data: 'login', orderable: false, visible: false},
            {label: ESR.lang.coef, data: 'coef', orderable: true, visible: false},
            {label: ESR.lang.terminated_on, data: 'dismised_date', orderable: true, visible: false}
        ];

        // Unshift 'ID' column at the beginning
        columns.unshift(columnDefinitions.shift());

        // Push the rest of the columns
        columns.push(...columnDefinitions);
    }


    const columnDefs = [
        {
            targets: canEditUsers ? 2 : 1, // Actions
            width: '60px',
            className: 'text-center'
        },
    ]


    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    let toolbarButtons = [];

    if (canEditOther) {
        function callbackBtnEdit(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            popupEditUser(elRow.data());
        }

        function callbackBtnRemove(e) {
            e.preventDefault();

            const elRow = table.row('.selected');
            if (!elRow.node()) return;   // "No row selected."
            const rowData = elRow.data();

            ESR.Popup.delete({
                title: rowData.name,
                html: `<p>Datele despre utilizator vor fi șterse definitiv, numele acestuia nu va în rapoartele generate. </p>`,
                action: 'esr_delete_user',
                id: rowData.id
            })
        }

        function callbackBtnResetPassword(e) {
            e.preventDefault();

            const elRow = table.row('.selected');
            if (!elRow.node()) return;   // "No row selected."
            const rowData = elRow.data();

            popupResetPassword(rowData.id, rowData.name)
        }

        toolbarButtons = [
            HelperTable.btnColvis(),
            HelperTable.btnDownloads(),
            // HelperTable.btnAdd(e => callbackBtnAdd(e)),
            HelperTable.createButton( 'Resetează Parola', 'btn btn-sm btn-neutral btn-reset-password btn-disabled', callbackBtnResetPassword),
            HelperTable.btnEdit(e => callbackBtnEdit(e)),
            HelperTable.btnRemove(e => callbackBtnRemove(e)),
        ]
    }


    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        columnDefs: columnDefs,
        stateSave: true,
        order: [
            [1, 'asc']
        ],
        pageLength: 20,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            topStart: {
                buttons: toolbarButtons
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()

            if (canEditOther) {
                const colRoleIndex = canViewTools ? 3 : 2;
                const colRole = api.column(colRoleIndex)
                const colRoleStateValue = state?.columns[colRoleIndex]?.search?.search ?? ''

                const optionsRoles = Object.values(ESR.user_roles).map(function (value) {
                    return {value: value, label: value}
                })

                const elSelectRoles = ESR.View.select({
                    value: colRoleStateValue,
                    placeholder: 'Toate rolurile',
                    class: 'select select-bordered select-sm',
                    options: optionsRoles
                }).on('change', function () {
                    console.log($(this).val())
                    colRole.search($(this).val(), {exact: false}).draw();
                });

                $('.dt-layout-row:eq(0) >.dt-layout-end').prepend(elSelectRoles)
            }
        },
    });


    if (canEditOther) {
        const btnRowEdit = table.buttons().container().find('.btn-row-edit')
        const btnRowRemove = table.buttons().container().find('.btn-row-remove')
        const btnResetPassword = table.buttons().container().find('.btn-reset-password')
        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove, btnResetPassword)
        });
    }


}